import { useEffect } from "react";

/**
 * Handles legacy URL redirects from the old chathero.ai site to new Lovable URLs.
 * Uses window.location directly to be SSG-safe (no React Router hooks at module level).
 */
const REDIRECTS: Record<string, string> = {
  "/produkte/ki-chatbot": "/produkte/ai-agent",
  "/produkte/conversational-commerce": "/loesungen/ecommerce",
  "/produkte/helpdesk": "/loesungen/kundenservice",
  "/produkte/ki-plattform": "/produkte/ai-agent-plattform",
  "/loesungen/engagement": "/loesungen/marketing",
  "/loesungen/support": "/loesungen/kundenservice",
  "/anwendungsfaelle/conversational-marketing": "/loesungen/marketing",
  "/anwendungsfaelle/e-commerce-und-vertrieb": "/loesungen/ecommerce",
  "/anwendungsfaelle/customer-service": "/loesungen/kundenservice",
  "/loesungspartner-programm": "/solution-partner",
  "/kontakt-uns": "/kontakt",
  "/contactus": "/kontakt",
  "/newsroom": "/blog",
  "/newsroom/chathero-ai-revolutionizes-e-commerce": "/blog",
  "/newsroom/Steigern-Sie-Ihr-Geschaeft-mit-AI-ChatGPT-4-Omni": "/blog",
  "/newsroom/konversationshandel-mit-chatgpt4o": "/blog",
  "/newsroom/whatsapp-integration-ai-chatbot-broadcasting": "/blog",
  "/newsroom/Steigern-Sie-die-Produktivitaet-Ihrer-Mitarbeiter-mit-KI": "/blog",
};

const RedirectHandler = () => {
  useEffect(() => {
    const path = window.location.pathname;

    if (REDIRECTS[path]) {
      window.location.replace(REDIRECTS[path]);
      return;
    }

    if (path.startsWith("/newsroom/")) {
      window.location.replace("/blog");
      return;
    }

    if (path.startsWith("/anwendungsfaelle/")) {
      window.location.replace("/");
      return;
    }
  }, []);

  return null;
};

export default RedirectHandler;
